import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { AppShell } from '@/components/organisms/AppShell';
import { HelmetIcon } from '@/components/ui/HelmetIcon';
import type { RouterContext } from '@/router';

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <HelmetIcon />
      <AppShell>
        <Outlet />
      </AppShell>
    </>
  ),
});
